module.exports = __webpack_public_path__ + "assets/img/2281591947409_.pic_hd.2f09e6f9.jpg";